export const BASE_URL = "https://bms-services.jabulanimerkato.com/api";
export const IMAGE_URL = "https://bms-services.jabulanimerkato.com";
export const LEASE_DOCUMENT_URL = "https://bms-services.jabulanimerkato.com";

// export const BASE_URL = "http://localhost:8000/api";
// export const IMAGE_URL = "http://localhost:8000";
// export const LEASE_DOCUMENT_URL = "http://localhost:8000";
